const html = document.querySelector('html');
const body = document.querySelector('body');
const mobileMenu = document.querySelector('.mobile-menu-trigger');
const navMenu = document.querySelector('.mobile-menu');
const header = document.querySelector('.headerOnScroll');

mobileMenu.addEventListener('click', () => {
    body.classList.toggle('overflow-hidden');
    html.classList.toggle('overflow-hidden');
    mobileMenu.classList.toggle('active');
    navMenu.classList.toggle('active');

    const isMenuOpen = mobileMenu.classList.contains('active');
    if (!isMenuOpen) {
        const activeSubmenus = document.querySelectorAll(
            '[class*="-submenu"].active'
        );
        activeSubmenus.forEach((submenu) => submenu.classList.remove('active'));
    }
});

// Search trigger
const searchTrigger = document.querySelector('#search-trigger');
const searchContainer = document.querySelector('.search-container');
const searchClose = document.querySelector('#search-close');
const searchOverlay = document.querySelector('#search-overlay');
const searchContent = document.querySelector('#search-content');

function openSearch() {
    searchContainer.classList.remove('hidden');
    searchContainer.classList.add('flex', 'items-center', 'justify-center');
    body.classList.add('overflow-hidden');
    html.classList.add('overflow-hidden');
    setTimeout(() => {
        const searchInput = searchContainer.querySelector('input[name="s"]');
        if (searchInput) searchInput.focus();
    }, 100);
}

function closeSearch() {
    searchContainer.classList.add('hidden');
    searchContainer.classList.remove('flex', 'items-center', 'justify-center');
    body.classList.remove('overflow-hidden');
    html.classList.remove('overflow-hidden');
}

if (searchTrigger && searchContainer) {
    searchTrigger.addEventListener('click', openSearch);
}

if (searchClose && searchContainer) {
    searchClose.addEventListener('click', closeSearch);
}

if (searchOverlay && searchContent) {
    searchOverlay.addEventListener('click', (e) => {
        if (e.target === searchOverlay) {
            closeSearch();
        }
    });

    searchContent.addEventListener('click', (e) => {
        e.stopPropagation();
    });
}

// Cerrar con ESC
document.addEventListener('keydown', (e) => {
    if (
        e.key === 'Escape' &&
        searchContainer &&
        !searchContainer.classList.contains('hidden')
    ) {
        closeSearch();
    }
});

// Header scroll detection
if (header) {
    let lastScrollY = window.scrollY;
    
    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        
        if (currentScrollY > 200) {
            header.classList.add('headerScrolled');
        } else {
            header.classList.remove('headerScrolled');
        }
        
        lastScrollY = currentScrollY;
    });
}

// Mobile search input focus/blur handling
function initMobileSearchHandling() {
    const searchInput = document.querySelector('#search-form input');
    
    if (searchInput && window.innerWidth <= 767) {
        searchInput.addEventListener('focus', () => {
            body.classList.add('overflow-hidden');
            html.classList.add('overflow-hidden');
            console.log('focus');
        });
        
        // Cuando el input pierde focus
        searchInput.addEventListener('blur', () => {
            const isMenuOpen = mobileMenu.classList.contains('active');
            if (!isMenuOpen) {
                body.classList.remove('overflow-hidden');
                html.classList.remove('overflow-hidden');
                console.log('blur');
            }
        });
    }
}

// Initialize mobile search handling when DOM is ready
document.addEventListener('DOMContentLoaded', initMobileSearchHandling);
